import { render, staticRenderFns } from "./NotificationChannels.vue?vue&type=template&id=ea16cb86"
import script from "./NotificationChannels.vue?vue&type=script&lang=js"
export * from "./NotificationChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports